import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import config from "config.ts";

import "./CreatorCard.scss";

const CreatorCard = ({ creator }) => {
  const { getLanguageCulture } = useContent();

  const backgroundSrc = creator.CreatorThumbFileLocationPreview
    ? creator.CreatorThumbFileLocationPreview
    : `${config.api.resource}/assets/images/track-blog-cover.png`;

  return (
    <div className="creator-card-wrapper">
      <a
        href={`/${getLanguageCulture().substring(0, 2)}/stage/${
          creator.CreatePageUrl
        }`}
      >
        <div className="creator-container">
          <div className="creator-card-image">
            <Image alt="" src={backgroundSrc} />
          </div>
          <div className="user-logo">
            <Image src={creator.UserLogo} alt="" />
          </div>
          <div className="user-name">{creator.CreatorName}</div>
        </div>
      </a>
    </div>
  );
};

export default CreatorCard;
